import request from '@/plugins/axios'

// 员工详情
export const apiStaffDetail = (params: any) => request.get('/staff.staff/detail', { params })

// 薪酬规则详情
export const apiSalaryRuleDetail = (params: any) => request.get('/staff.salaryRule/detail', { params })

// 薪酬规则状态更新
export const apiSalaryRuleStatus = (data: any) => {
  return request({
    url: '/staff.salaryRule/status',
    method: 'post',
    data
  })
}

// 排班列表
export const apiScheduleLists = (params: any) => request.get('/staff.schedule/lists', { params })

// 排班状态更新
export const apiScheduleStatus = (data: any) => {
  return request({
    url: '/staff.schedule/status',
    method: 'post',
    data
  })
}

// 薪酬结算列表
export const apiSalarySettlementLists = (params: any) => request.get('/staff.salarySettlement/lists', { params })

// 薪酬结算确认
export const apiSalarySettlementConfirm = (data: any) => {
  return request({
    url: '/staff.salarySettlement/confirm',
    method: 'post',
    data
  })
}

// 薪酬结算支付
export const apiSalarySettlementPay = (data: any) => {
  return request({
    url: '/staff.salarySettlement/pay',
    method: 'post',
    data
  })
}

// 转单记录详情
export const apiTransferRecordDetail = (params: any) => request.get('/staff.transferRecord/detail', { params })

// 获取所有工种列表（不分页）
export const apiWorkerTypeAllList = (params?: any) => request.get('/staff.workerType/allList', { params })

// 物料列表
export const apiMaterialLists = (params: any) => request.get('/material.material/lists', { params })

// 物料详情
export const apiMaterialDetail = (params: any) => request.get('/material.material/detail', { params })

// 新增物料
export const apiMaterialAdd = (data: any) => {
  return request({
    url: '/material.material/add',
    method: 'post',
    data
  })
}

// 编辑物料
export const apiMaterialEdit = (data: any) => {
  return request({
    url: '/material.material/edit',
    method: 'post',
    data
  })
}

// 删除物料
export const apiMaterialDelete = (data: any) => {
  return request({
    url: '/material.material/delete',
    method: 'post',
    data
  })
}

// 物料状态更新
export const apiMaterialStatus = (data: any) => {
  return request({
    url: '/material.material/status',
    method: 'post',
    data
  })
}

// 物料库存统计
export const apiMaterialInventoryStats = (data: any) => {
  return request({
    url: '/material.material/inventoryStats',
    method: 'post',
    data
  })
}

// 物料分类列表
export const apiMaterialCategoryList = (data?: any) => {
  return request({
    url: '/material.material/categoryList',
    method: 'get',
    data: data || {}
  })
}
// 物料分类详情
export const apiMaterialCategoryDetail = (params: any) => request.get('/material.material/categoryDetail', { params })

// 新增物料分类
export const apiMaterialCategoryAdd = (data: any) => {
  return request({
    url: '/material.material/categoryAdd',
    method: 'post',
    data
  })
}

// 编辑物料分类
export const apiMaterialCategoryEdit = (data: any) => {
  return request({
    url: '/material.material/categoryEdit',
    method: 'post',
    data
  })
}

// 删除物料分类
export const apiMaterialCategoryDelete = (data: any) => {
  return request({
    url: '/material.material/categoryDelete',
    method: 'post',
    data
  })
}

// 物料分类状态更新
export const apiMaterialCategoryStatus = (data: any) => {
  return request({
    url: '/material.material/categoryStatus',
    method: 'post',
    data
  })
}

// 仓库列表
export const apiWarehouseList = (data?: any) => {
  return request({
    url: '/material.material/warehouseList',
    method: 'get',
    data: data || {}
  })
}

// 采购订单列表
export const apiPurchaseOrderList = (data: any) => {
  return request({
    url: '/material.material/purchaseOrderList',
    method: 'get',
    data
  })
}

// 入库记录列表
export const apiInboundList = (data: any) => {
  return request({
    url: '/material.material/inboundList',
    method: 'get',
    data
  })
}

// 出库记录列表
export const apiOutboundList = (data: any) => {
  return request({
    url: '/material.material/outboundList',
    method: 'get',
    data
  })
}

// 库存盘点列表
export const apiInventoryCheckList = (data: any) => {
  return request({
    url: '/material.material/inventoryCheckList',
    method: 'get',
    data
  })
}

// 价格调整列表
export const apiPriceAdjustmentList = (data: any) => {
  return request({
    url: '/material.material/priceAdjustmentList',
    method: 'get',
    data
  })
}

// 供应商账单列表
export const apiSupplierBillList = (data: any) => {
  return request({
    url: '/material.material/supplierBillList',
    method: 'get',
    data
  })
}

// 供应商相关接口
// 供应商列表
export const apiSupplierList = (params: any) => request.get('/material.supplier/lists', { params })

// 供应商详情
export const apiSupplierDetail = (params: any) => request.get('/material.supplier/detail', { params })

// 新增供应商
export const apiSupplierAdd = (data: any) => {
  return request({
    url: '/material.supplier/add',
    method: 'post',
    data
  })
}

// 编辑供应商
export const apiSupplierEdit = (data: any) => {
  return request({
    url: '/material.supplier/edit',
    method: 'post',
    data
  })
}

// 供应商状态更新（合作状态）
export const apiSupplierStatus = (data: any) => {
  return request({
    url: '/material.supplier/status',
    method: 'post',
    data
  })
}

// 供应商信用评级更新
export const apiSupplierRating = (data: any) => {
  return request({
    url: '/material.supplier/rating',
    method: 'post',
    data
  })
}

// 获取供应商账号详情
export const apiSupplierAccountDetail = (params: any) => request.get('/material.SupplierAccount/getAccount', { params })

// 修改供应商账号
export const apiSupplierAccountEdit = (data: any) => {
  return request({
    url: '/material.SupplierAccount/edit',
    method: 'post',
    data
  })
}

// 下载物料导入模板
export const apiMaterialImportTemplate = () => {
  return request({
    url: '/material.material/getImportTemplate',
    method: 'get'
  })
}

// 批量导入物料
export const apiMaterialBatchImport = (data: any) => {
  return request({
    url: '/material.material/batchImport',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
